import { Directive, TemplateRef } from '@angular/core'

@Directive({ selector: 'ng-template[customInput]' })
export class CustomInputDirective {
  constructor(public templateRef: TemplateRef<any>) {}
}
